<template>
  <div class="inline-block relative movie cursor-pointer" @click="open = true">
    <img class="w-[85px] md:w-[102px]" width="102" src="../assets/top/play-movie.svg" alt="">
    <img class="w-[30px] mx-auto mt-1 icon-play" src="../assets/common/play.svg" alt="">
  </div>
  <transition name="fade">
    <div v-show="open" class="z-20 h-screen w-full fixed top-0 inset-0 flex items-center justify-center">
      <div @click="open = false" class="cursor-pointer bg-black opacity-75 w-full h-full absolute top-0"></div>
      <div class="close cursor-pointer" @click="open = false"></div>
      <transition name="fade-delay">
        <div v-if="open" class="wrap">
          <div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/659516244?autoplay=1" frameborder="0" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;" title="画面収録 2021-12-23 112237"></iframe></div>
        </div>
      </transition>
    </div>
  </transition>

</template>

<script>
export default {
  name: "Modal",
  data() {
    return {
      open: true
    }
  },
}
</script>

<style scoped>
.wrap {
  width: 90%;
  max-width: 1280px;
  background: linear-gradient(#75333A, #2439A0);
}

.close {
  @apply fixed top-8 right-8 w-6 h-6 md:w-8 md:h-8 z-20;
  transform: rotate(45deg);
}

.close:after {
  content: '';
  display: inline-block;
  width: 100%;
  height: 100%;
  @apply border-white absolute top-0 border-t border-r;
  top: 50%;
  left: -50%;
}

.close:before {
  content: '';
  display: inline-block;
  width: 100%;
  height: 100%;
  @apply border-white absolute top-0 border-b border-l;
  top: calc(-50% + 1px);
  left: calc(50% - 1px) ;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-delay-enter-active,
.fade-delay-leave-active {
  transition: opacity 0.5s ease 0.3s, transform 0.5s ease 0.3s;
}

.fade-delay-enter-from,
.fade-delay-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

</style>